import { Flex } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { ReactComponent as OktaIcon } from '@elementary/common-ui/assets/okta.svg';
import { ReactComponent as AzureADIcon } from '@elementary/common-ui/assets/azure-ad.svg';
import { ScimSourceType } from '../types';

export const PROVISIONING_SOURCE_MAP: Record<
  ScimSourceType,
  { label: string; icon?: React.ReactNode; value: string }
> = {
  [ScimSourceType.OKTA]: {
    label: 'Okta',
    icon: <OktaIcon width={16} height={16} />,
    value: ScimSourceType.OKTA,
  },
  [ScimSourceType.AZURE_AD]: {
    label: 'Azure AD',
    icon: <AzureADIcon width={16} height={16} />,
    value: ScimSourceType.AZURE_AD,
  },
  [ScimSourceType.OTHER]: {
    label: 'Other',
    value: ScimSourceType.OTHER,
  },
};

const ProvisioningSource = ({ source }: { source: ScimSourceType }) => {
  const { label, icon } = PROVISIONING_SOURCE_MAP[source];
  return (
    <Flex sx={{ alignItems: 'center', gap: 1 }}>
      {icon}
      <Typography>{label}</Typography>
    </Flex>
  );
};

export default ProvisioningSource;
